"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createImThemeOptions = require("./createImThemeOptions");
Object.keys(_createImThemeOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createImThemeOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createImThemeOptions[key];
    }
  });
});